import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-input-radio__wrap" }
const _hoisted_2 = ["name", "value", "checked", "disabled"]
const _hoisted_3 = { class: "c-input-radio__text" }

import { computed } from 'vue';
import commons from '@/common/store/modules/commons';


export default /*@__PURE__*/_defineComponent({
  __name: 'InputRadio',
  props: {
  modelValue: [String, Number, Boolean] as unknown as () => string | number | boolean,
  name: { type: String, required: true },
  value: { type: [String, Number, Boolean], required: true },
  kind: { type: String, default: 'main' },
  error: { type: String, default: '' },
  disabled: { type: Boolean, default: false }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const colorCode = computed(() => commons?.colorCode);

function onChange() {
  emit('update:modelValue', props.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass(["c-input-radio__label", [
        `-${__props.kind}`,
        {
          '-checked': __props.modelValue === __props.value,
          '-disabled': __props.disabled
        }
      ]])
    }, [
      _createElementVNode("span", {
        class: "c-input-radio__icon__wrap",
        style: _normalizeStyle({
          borderColor: __props.modelValue === __props.value && __props.kind === 'main' ? colorCode.value : ''
        })
      }, [
        _createElementVNode("input", {
          type: "radio",
          name: __props.name,
          value: __props.value,
          checked: __props.modelValue === __props.value,
          class: _normalizeClass(["c-input-radio", {
            'c-input-radio--error': __props.error
          }]),
          disabled: __props.disabled,
          onChange: onChange
        }, null, 42, _hoisted_2),
        _withDirectives(_createElementVNode("i", {
          class: "c-input-radio__icon",
          style: _normalizeStyle({ backgroundColor: __props.kind === 'main' ? colorCode.value : '' })
        }, null, 4), [
          [_vShow, __props.modelValue === __props.value]
        ])
      ], 4),
      _createElementVNode("span", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ], 2)
  ]))
}
}

})